import { useMemo } from 'react';
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { CatHeading } from '@blocks-react/components/Heading';
import { BlocksCheckboxChangeEvent } from '@blocks-web-components/events';
import { NotificationOrderCheckboxProps, OrderObject } from '../types';

export const NotificationOrderStatusCheckbox = ({
  label,
  handleChange,
  value,
  orderStatusValue
}: NotificationOrderCheckboxProps) => {
  const checkedStatus = useMemo(
    () =>
      !!orderStatusValue &&
      orderStatusValue?.some((d: OrderObject) => d.orderStatus === value.value),
    [orderStatusValue, value]
  );
  return (
    <div className="mb-2">
      <CatCheckboxField
        checked={checkedStatus}
        name={label}
        id={label}
        data-testid={label}
        onBlCheckboxChange={(e: BlocksCheckboxChangeEvent) =>
          handleChange(e, value)
        }
      >
        <CatHeading variant="body-sm" aria-label={label}>
          {label}
        </CatHeading>
      </CatCheckboxField>
    </div>
  );
};
